import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import NotFoundPage from "./PAGES/404";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import ContactPage from "./PAGES/CONTACT_PAGE";
import HomePage from "./PAGES/HOME_PAGE";
import PatientsPage from "./PAGES/PATIENTS";
import SponsorsPage from "./PAGES/SPONSORS";
import PhysiciansPage from "./PAGES/PHYSICIANS";
import Aboutpage from "./PAGES/ABOUT";
import JobPage from "./PAGES/JOB_APPLICATION_PAGE";
import PrivacyPolicy from "./PAGES/PRIVACY_PAGE";
import TcPage from "./PAGES/TERMS_CONDITIONS";
import NetworkPage from "./PAGES/NETWORK_PAGE";
import GoToTopButton from "./COMPONENTS/GO_TO_TOP";
import ComingSoonPage from "./PAGES/COMING_SOON";
import PageTransition from "./COMPONENTS/ANIMATION/PageTransition";

// Import the new GoToTopButton component

function App() {
  // State to control the visibility of the 'Go to Top' button
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  // Effect to handle the scroll event
  useEffect(() => {
    const handleScroll = () => {
      // If the scroll position is more than 100px, show the button
      if (window.scrollY > 100) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const location = useLocation();

  return (
    <div
      className="app-container"
      style={{ width: "100%", overflow: "clip" }}
    >
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="*" element={<PageTransition><NotFoundPage /></PageTransition>} />
          <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
          <Route path="/sponsors" element={<PageTransition><SponsorsPage /></PageTransition>} />
          <Route path="/physicians" element={<PageTransition><PhysiciansPage /></PageTransition>} />
          <Route path="/patients" element={<PageTransition><PatientsPage /></PageTransition>} />
          <Route path="/about" element={<PageTransition><Aboutpage /></PageTransition>} />
          <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
          <Route path="/job-application" element={<PageTransition><JobPage /></PageTransition>} />
          <Route path="/privacy-policy" element={<PageTransition><PrivacyPolicy /></PageTransition>} />
          <Route path="/terms" element={<PageTransition><TcPage /></PageTransition>} />
          <Route path="/coming_soon" element={<PageTransition><ComingSoonPage /></PageTransition>} />

          {/* New network page route */}
          <Route path="/network/:section" element={<PageTransition><NetworkPage /></PageTransition>} />
        </Routes>
      </AnimatePresence>

      {/* Go to Top Button */}
      <AnimatePresence>
        {showScrollToTop && <GoToTopButton onClick={scrollToTop} />}
      </AnimatePresence>
    </div>
  );
}

export default App;
